import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaObras: ['administracao'],
    removeTipoConsultaObras: ['tipo'],
    removeNaturezaConsultaObras: ['natureza'],
    removeExercicioConsultaObras: [],
    removeNumeroConsultaObras: [],
    removeDescricaoConsultaObras: [],
    removeStatusConsultaObras: [],
    removeInicioInicialConsultaObras: [],
    removeInicioFinalConsultaObras: [],
    removeFimInicialConsultaObras: [],
    removeFimFinalConsultaObras: [],
    setMostraAplicarFiltroConsultaObras: [],
    limpaFiltroConsultaObras: [],
    aplicarFiltroConsultaObras: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    tipo: [],
    natureza: [],
    exercicio: '',
    numero: '',
    descricao: '',
    inicioInicial: '',
    inicioFinal: '',
    fimInicial: '',
    fimFinal: '',
    status: '',
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeTipo = (state = INITIAL_STATE, action) => {
    state.tipo.splice(state.tipo.indexOf(action.tipo), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.tipo = Array.from(state.tipo)
    return { ...state, mostraAplicarFiltro: true }
}

const removeNatureza = (state = INITIAL_STATE, action) => {
    state.natureza.splice(state.natureza.indexOf(action.natureza), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.natureza = Array.from(state.natureza)
    return { ...state, mostraAplicarFiltro: true }
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}

const removeNumero = (state = INITIAL_STATE, action) => {
    return { ...state, numero: '', mostraAplicarFiltro: true }
}

const removeDescricao = (state = INITIAL_STATE, action) => {
    return { ...state, descricao: '', mostraAplicarFiltro: true }
}

const removeInicioInicial = (state = INITIAL_STATE, action) => {
    return { ...state, inicioInicial: '', mostraAplicarFiltro: true }
}

const removeInicioFinal = (state = INITIAL_STATE, action) => {
    return { ...state, inicioFinal: '', mostraAplicarFiltro: true }
}

const removeFimInicial = (state = INITIAL_STATE, action) => {
    return { ...state, fimInicial: '', mostraAplicarFiltro: true }
}

const removeFimFinal = (state = INITIAL_STATE, action) => {
    return { ...state, fimFinal: '', mostraAplicarFiltro: true }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_OBRAS]: removeAdministracao,
    [Types.REMOVE_TIPO_CONSULTA_OBRAS]: removeTipo,
    [Types.REMOVE_NATUREZA_CONSULTA_OBRAS]: removeNatureza,
    [Types.REMOVE_EXERCICIO_CONSULTA_OBRAS]: removeExercicio,
    [Types.REMOVE_NUMERO_CONSULTA_OBRAS]: removeNumero,
    [Types.REMOVE_DESCRICAO_CONSULTA_OBRAS]: removeDescricao,
    [Types.REMOVE_INICIO_INICIAL_CONSULTA_OBRAS]: removeInicioInicial,
    [Types.REMOVE_INICIO_FINAL_CONSULTA_OBRAS]: removeInicioFinal,
    [Types.REMOVE_FIM_INICIAL_CONSULTA_OBRAS]: removeFimInicial,
    [Types.REMOVE_FIM_FINAL_CONSULTA_OBRAS]: removeFimFinal,
    [Types.REMOVE_STATUS_CONSULTA_OBRAS]: removeStatus,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_OBRAS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_OBRAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_OBRAS]: aplicarFiltro,
})
